<template>
  <div class="mt-5">
    <form @submit.prevent="roleUpdate">

      <h3>Role Create</h3>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control form-control-lg" v-model="name"/>
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block mt-2">Create</button>

    </form>
  </div>
</template>

<script>
import axios from "axios";
import tokenRefresh from "@/utils/tokenRefresh";
import statusCheck from "@/utils/statusCheck";

export default {
  name: "RoleEdit.vue",
  data() {
    return {
      name: '',
    }
  },
  mounted() {
    let roleId = window.location.pathname.split("/").pop();
    axios.get(process.env.VUE_APP_CRAWLING_URL + "/api/role/edit/" + roleId)
        .then((response) => {
              this.name = response.data['name'];
            }
        )
  },
  methods: {
    roleUpdate: function () {
      let userId = window.location.pathname.split("/").pop();
      const {name,} = this;
      axios.put(process.env.VUE_APP_CRAWLING_URL + "/api/role/" + userId, {name})
          .then((response) => {
                if (response.status === 200) {
                  tokenRefresh()
                  this.$router.push({name: "roles"});
                }
              }
          )
          .catch((error) => {
                statusCheck(error.response.status);
              }
          )
    }
  }
}
</script>

<style scoped>

</style>